import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/filter';
var perra_inicializada = false;

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
    routerActivePath: any;
    menus = [
        {
            id: 0,
            imgSrc: 'assets/img/menu1.png',
            imgSrcOut: 'assets/img/menu1.png',
            imgSrcOn: 'assets/img/menu1-b.png',
            active: false,
            link: '/about'
        },
        {
            id: 1,
            imgSrc: 'assets/img/menu2.png',
            imgSrcOut: 'assets/img/menu2.png',
            imgSrcOn: 'assets/img/menu2-b.png',
            active: false,
            link: '/collections'
        },
        {
            id: 2,
            imgSrc: 'assets/img/menu3.png',
            imgSrcOut: 'assets/img/menu3.png',
            imgSrcOn: 'assets/img/menu3-b.png',
            active: false,
            link: '/experience'
        },
        {
            id: 3,
            imgSrc: 'assets/img/menu4.png',
            imgSrcOut: 'assets/img/menu4.png',
            imgSrcOn: 'assets/img/menu4-b.png',
            active: false,
            link: '/contact'
        }
    ]

    constructor(route: ActivatedRoute, private router: Router) {
        router.events.subscribe((url: any) => {
            // console.log(url);
            this.routerActivePath = router.url;
            // console.log( this.routerActivePath); 

            this.menus.forEach(menu => {
                if (this.routerActivePath === menu.link) {
                    menu.active = true;
                } else {
                    menu.active = false;
                }
            })
        });

    }

    ngOnInit() {
        console.log(this.routerActivePath);
        perra_inicializada = false;

    }
    ngAfterViewInit() {
        setInterval(function () {
            var height = window.innerHeight;
            var width = window.innerWidth;
            if (height <= 637) {
                var element = document.getElementsByClassName("mt-5");
                if (element.length > 0) {
                    element[0].classList.add("pantalla-widescreen");
                }
            } else {
                //                    $(".row.mt-5.text-center").removeClass("pantalla-widescreen");
                var element = document.getElementsByClassName("mt-5");
                if (element.length > 0) {
                    element[0].classList.remove("pantalla-widescreen")
                }
            }
        }, 500);
    }
    onMouseOver(id): void {
        this.menus[id].imgSrc = this.menus[id].imgSrcOn;
    }
    onClickAMenu(element): void {
        //        $(".row.mt-5.text-center").addClass("perra");

    }
    onMouseOut(id): void {
        this.menus[id].imgSrc = this.menus[id].imgSrcOut;
    }

}



// WEBPACK FOOTER //
// ./src/app/footer/footer.component.ts